export enum AuthenticationRouteNames {
    LOGIN = 'login',
    RESET_PASSWORD = 'reset-password',
    ACTIVATE_USER = 'activate-user',
    INSTANT_LOGIN = 'instant-login',
}
